import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { NationalityItem, Nationality } from '../models';

export class NationalityApi extends ApiModule {
  protected endpoint = '/nationality';

  public async pageNationalities(params: any) {
    return this.api.post<PaginatedResponseData<NationalityItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadNationalityDetails(id: number) {
    return this.api.get<Nationality>(`${this.endpoint}?id=${id}`);
  }

  public saveNationality(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteNationality(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
